import { create } from 'zustand';

interface BreadcrumbStore {
  /**
   * Map of an opaque URL path segment (usually an entity id) → the human
   * label to show for it in the AppHeader breadcrumb. A detail route
   * registers its entity name here so the trail reads
   * `Questionnaires / Vendor Onboarding / Summary` instead of the raw id.
   */
  overrides: Record<string, string>;
  setOverride: (segment: string, label: string) => void;
  clearOverride: (segment: string) => void;
}

export const useBreadcrumbStore = create<BreadcrumbStore>(set => ({
  overrides: {},
  setOverride: (segment, label) =>
    set(state =>
      state.overrides[segment] === label
        ? state
        : { overrides: { ...state.overrides, [segment]: label } },
    ),
  clearOverride: segment =>
    set(state => {
      if (!(segment in state.overrides)) return state;
      const { [segment]: _removed, ...rest } = state.overrides;
      return { overrides: rest };
    }),
}));
